module.exports = __webpack_public_path__ + "img/laos.19932f25.svg";